export function isMac(): boolean {
  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  const p = uaData?.platform || navigator.platform || navigator.userAgent;
  return /mac|iphone|ipad/i.test(p);
}

export const modLabel = () => (isMac() ? '⌘' : 'Ctrl+');
export const numModLabel = () => (isMac() ? '⌘' : 'Alt+');

/**
 * onKeyDown for an inline confirm, form or panel: Esc cancels it, and goes no further (a
 * drawer, or the terminal under it, doesn't take it as well).
 */
export const escCloses =
  (close: () => void) =>
  (e: { key: string; preventDefault(): void; stopPropagation(): void }): void => {
    if (e.key !== 'Escape') return;
    e.preventDefault();
    e.stopPropagation();
    close();
  };
